import { SourceType } from 'module/api/filter/types';
import { useTranslation } from 'module/hooks/use-translation';
import { FieldType } from 'module/types/filter-field/field/field';
import { MultiSelectField } from 'module/types/filter-field/field/filterable-field';
import { useGetAllActiveExternalUsersQuery } from 'queries/member';
import { useMemo } from 'react';

export const useSignalCompanyNamesField = (
  fieldId: number,
): { field: MultiSelectField; isLoading: boolean } => {
  const { data: externalUsers, isLoading } =
    useGetAllActiveExternalUsersQuery();
  const fieldLabel = useTranslation('signal.fields.company_name');

  const options = useMemo(() => {
    const companyMap = new Map<number, string>();

    (externalUsers ?? []).forEach((user) => {
      if (user?.company?.companyId && user?.company?.companyName) {
        companyMap.set(user.company.companyId, user.company.companyName);
      }
    });

    return Array.from(companyMap.entries()).map(([value, label]) => ({
      value,
      label,
      active: true,
    }));
  }, [externalUsers]);

  return useMemo(
    () => ({
      field: {
        fieldId,
        fieldName: 'companyId',
        fieldLabel,
        type: FieldType.MultiSelect,
        private: false,
        userCreated: false,
        metaData: { options },
        sourceType: SourceType.Signal,
      },
      isLoading,
    }),
    [fieldId, fieldLabel, options, isLoading],
  );
};
